import { connect } from 'react-redux';
import ProgressBar from './ProgressBar';

const mapStateToProps = state => ({
  paths: state.path.paths,
  farthestPath: state.path.farthestPath
});

export default connect(mapStateToProps)(ProgressBar);



// WEBPACK FOOTER //
// ../core/src/components/ProgressBar/index.js